import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  backgroundColor: "#dee3e6",
  flexGrow: 1,

  // Без своего контекста форматирования верхний margin первого потомка
  // (SessionBlock) схлопывается наружу и оставляет светлую полосу над серым.
  display: "flow-root",

  // Отступы от блока поиска и до футера остались прежними, но теперь они
  // внутри серого блока, а не светлыми полосами сверху и снизу.
  paddingTop: 30,
  paddingBottom: 30,

  [theme.down("md")]: {
    paddingTop: 20,
    paddingBottom: 20,
  },

  [theme.down("sm")]: {
    paddingTop: 15,
    paddingBottom: 15,
  },
}));

export const Block = styled("div")(({ theme }) => ({
  ...theme.mixins.flexJustifyBetween,
  alignItems: "flex-start",
  gap: 20,
  padding: "10px 0",

  [theme.down("lg")]: {
    flexDirection: "column",
  },
}));

export const LoadingBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  width: "100%",
  minHeight: 500,
  backgroundColor: "#dee3e6",
}));

export const ErrorBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  flexDirection: "column",
  width: "100%",
  minHeight: 500,
  backgroundColor: "#dee3e6",
}));

export const SessionBlock = styled("div")(({ theme }) => ({
  fontSize: 12,
  color: "#777",
  marginTop: 5,
}));

export const ModalBlock = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: 500,
  height: 'auto',
  padding: 20,

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  gap: 20,
  
  "&>button": {
    width: "100%",
    maxWidth: 200,
    padding: "10px 20px",
    color: "#fff",

    border: "none",
    borderRadius: 5,
    
    backgroundColor: theme.palette.searchButtonBg,
    cursor: "pointer",
    fontSize: 16,
    transition: "background-color 0.3s ease",
    
    "&:hover": {
      backgroundColor: theme.palette.hoverButtonBg,
    },
  },
}));
